// declare DB name, table name, key name in here

export const IDB_Names = {
  user: {
    DB_Name: 'userDB2',
    version: 13,
    stores: [
      {
        name: 'users',
        id: { keyPath: 'IDB_id', autoIncrement: true },
        indices: [
          { name: 'userId', keyPath: 'userId', options: { unique: true } },
          { name: 'roleId', keyPath: 'roleId' },
          { name: 'name', keyPath: 'name' },
          { name: 'phone', keyPath: 'phone' },
          { name: 'email', keyPath: 'email' },

          // only driver
          { name: 'driverId', keyPath: 'driverId' },
          { name: 'driverInfo', keyPath: 'driverInfo' },
          // table column setting (주문관리>자동최적화배차)
          { name: 'orderManageTableColumnsSetting', keyPath: 'orderManageTableColumnsSetting' },
          // settings table column setting
          { name: 'InvolvedDriverTableColumnSetting', keyPath: 'InvolvedDriverTableColumnSetting' },
          // 메시지관리 > 메시지 수동 발송(테이블 컬럼 설정)
          { name: 'messageManualSendTableColumnsSetting', keyPath: 'messageManualSendTableColumnsSetting' },
          // 메시지관리 > 메시지 자동 발송(테이블 컬럼 설정)
          { name: 'messageAutoTableColumnsSetting', keyPath: 'messageAutoTableColumnsSetting' },
          // 메시지관리 > 발송 이력 조회(테이블 컬럼 설정)
          { name: 'messageHistoryTableColumnsSetting', keyPath: 'messageHistoryTableColumnsSetting' },
          // 배차계획 > 3. 드라이버 선택 테이블 초기조건 (테이블 컬럼 설정)
          { name: 'driverSelectTableColumnsSetting', keyPath: 'driverSelectTableColumnsSetting' },
          // 모니터링 > 드라이버 선택 시 테이블 (테이블 컬럼 설정)
          { name: 'monitoringDriverSelectTableColumnsSetting', keyPath: 'monitoringDriverSelectTableColumnsSetting' },
          // 모니터링 > 3개 탭 (테이블 컬럼 설정)
          { name: 'monitoringTabsTableColumnsSetting', keyPath: 'monitoringTabsTableColumnsSetting' },
          // 배차계획 > 배차 결과 후 > 드라이버 오른 클릭 모달 (테이블 컬럼 설정)
          { name: 'routePlanConfirmTableColumnsSetting', keyPath: 'routePlanConfirmTableColumnsSetting' },
        ],
      },
    ],
  },
};
